import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Stack,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Divider,
} from "@mui/material";
import { t } from "i18next";
import { getInspStatusImage } from "../../services/inspectService";
import ZoomBox from "../train/ZoomBox";
import ZoomController from "../train/ZoomController";

interface BinImageModalProps {
  okPaths: string[];
  ngPaths: string[];
  score: number;
  setImageSrc: (src: string | null) => void;
}

export default function BinImageModal({ okPaths, ngPaths, score, setImageSrc }: BinImageModalProps) {
  const [zoomMode, setZoomMode] = useState(false);

  useEffect(() => {
    if (okPaths.length > 0) {
      handleImageClick(okPaths[0]);
    } else if (ngPaths.length > 0) {
      handleImageClick(ngPaths[0]);
    }
  }, [okPaths, ngPaths]);

  const handleImageClick = async (path: string) => {
    try {
      if (path) {
        const image = await getInspStatusImage(path);

        if (image) {
          setImageSrc(image);
        }
      }
    } catch (error) {
      console.error("이미지 불러오기 실패:", error);
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
      <Divider sx={{ mb: 1 }} />
      <Typography variant="h6" fontWeight={700}>
        [{score}]{t("ScoreRangeImageListMsg")}
      </Typography>
      <Box sx={{ display: "flex", gap: 2, height: "100%", mt: 1 }}>
        <Box sx={{ display: "flex", flexDirection: "column", height: "200px", flex: 1 }}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "bold", color: "error.main" }}>
            {t("NGImage")} ({ngPaths.length}{t("CountSuffix")})
          </Typography>
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              border: "1px solid var(--dk-border, #ccc)",
              borderRadius: 1,
            }}
          >
            <Table size="small">
              <TableBody>
                {ngPaths.length > 0 ? (
                  ngPaths.map((data, idx) => (
                    <TableRow
                      key={idx}
                      sx={{
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "var(--dk-surface-2, #f5f5f5)" },
                      }}
                      onClick={() => handleImageClick(data)}
                    >
                      <TableCell>{data.split("/").pop()}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell align="center">{t("NoDataMsg")}</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", height: "200px", flex: 1 }}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "bold", color: "primary.main" }}>
            {t("OKImage")} ({okPaths.length}{t("CountSuffix")})
          </Typography>
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              border: "1px solid var(--dk-border, #ccc)",
              borderRadius: 1,
            }}
          >
            <Table size="small">
              <TableBody>
                {okPaths.length > 0 ? (
                  okPaths.map((data, idx) => (
                    <TableRow
                      key={idx}
                      sx={{
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "var(--dk-surface-2, #f5f5f5)" },
                      }}
                      onClick={() => handleImageClick(data)}
                    >
                      <TableCell>{data.split("/").pop()}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell align="center">{t("NoDataMsg")}</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
        </Box>
      </Box>

      {/* ✅ 우측: 이미지 영역 */}
    </Box>
  );
}
